import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { getAiRankingForListing } from "@/services/v2/wantAdService";

// AI pairings for one listing, keyed by want-ad — the reverse of useAiRanking.
// Inert (enabled:false, empty map) until the tenant displays rankings.
export default function useListingAiRanking(
  { mlsListingKey, inventoryId },
  active = true,
) {
  const hasRef = !!mlsListingKey || !!inventoryId;
  const { data } = useQuery({
    queryKey: ["aiRankingForListing", mlsListingKey || null, inventoryId || null],
    queryFn: () => getAiRankingForListing({ mlsListingKey, inventoryId }),
    enabled: !!active && hasRef,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });

  return useMemo(() => {
    const result = data?.result;
    if (!result?.enabled || !result?.entries?.length) {
      return { enabled: false, byWantAdId: new Map() };
    }
    const byWantAdId = new Map();
    result.entries.forEach((e) => byWantAdId.set(Number(e.wantAdId), e));
    return { enabled: true, byWantAdId };
  }, [data]);
}
